module.exports = __webpack_public_path__ + "static/media/netflix_clone.4f81863c.PNG";